import { render, staticRenderFns } from "./DepartmentField.vue?vue&type=template&id=2cd59896"
import script from "./DepartmentField.vue?vue&type=script&lang=js"
export * from "./DepartmentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports